export default "__VITE_ASSET__B4Al4bYG__"